import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getRevenueStreamTags } from '../../../../api/lendingAPI/rblCalculatorSelector';
import { getCountry } from '../../../../iwIntlProvider/CountryProvider';
import { TooltipQuestionMarkSVG } from '../../../../svgComponents/tooltipQuestionMarkSVG/TooltipQuestionMarkSVG';
import approvedViewStyles from '../flexiApprovedView/FlexiApprovedView.module.css';
import { Tooltip } from '../../../ui/tooltip/Tooltip';
import messages from './RBLApprovedView.messages';
import styles from './RevenueStreamHeader.module.css';

const mapStateToProps = (state) => {
    return {
        revenueStreamTags: getRevenueStreamTags(state)
    };
};

function RevenueStreamHeader({ revenueStreamTags }) {
    const tagsCopy = revenueStreamTags.join(', ');
    return (
        <div
            className={styles.revenueStreamHeader}
            data-testid="header-revenue-stream-tags"
        >
            <FormattedMessage {...messages.revenueStream} />{' '}
            <span className={approvedViewStyles.headerBlue}>{tagsCopy}</span>
            {getCountry() === 'UK' && (
                <Tooltip
                    data-testid="revenue-stream-tag-tooltip"
                    message={
                        <FormattedMessage {...messages.revenueStreamTooltip} />
                    }
                >
                    <TooltipQuestionMarkSVG
                        className={`${styles.icon} ${styles.questionIcon}`}
                    />
                </Tooltip>
            )}
        </div>
    );
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(RevenueStreamHeader);
